import { EndpointSetting } from "@/constants/app/type";
import { EsimState } from "../types";

export const callbackEsimCollectionPublicList: EndpointSetting["caller"] = (
  state: EsimState,
  action,
) => {
  const payload = action.payload ?? {};
  const collections = Array.isArray(payload.collections) ? payload.collections : [];
  state.esim_collection_public_list.data.collections = collections;
  state.esim_collection_public_list.data.totalRecords = payload.pagination?.total ?? collections.length;
};
